export default {
    language: 'da-DK',
    navigation: 'Tilbage',
    home: {
        title: 'Yacht Malingsberegner',
        subtitle:
            'Lad os hjælpe dig med at vælge den bedste bundmaling til din båd og beregne den mængde, du har brug for.',
        findProduct: 'Find produkt',
        calculateVolume: 'Beregn Produktmængde'
    },
    find: {
        questions: {
            type: 'Vælg <strong>bådtype</strong>?',
            material: 'Bådens <strong>materialer</strong>?',
            sailFrequency: '<strong>Hvor ofte</strong> bruger du din båd??',
            paintLocation: '<strong>Hvor</strong> maler du din båd??',
            waterType: 'I hvilken <strong>type vand</strong> bruger du din båd?'
        },
        answers: {
            help: 'Har du brug for hjælp til at vælge bundmaling?',

            type: [
                {
                    label: 'Sejlbåd',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorbåd (lav hastighed)',
                    sublabel: 'op til 20 knob',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motorbåd (høj hastighed)',
                    sublabel: 'hurtigere end 20 knob',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Glasfiber',
                    value: 'plastic'
                },
                {
                    label: 'Jern',
                    value: 'iron'
                },
                {
                    label: 'Træ',
                    value: 'wood'
                },
                {
                    label: 'Aluminium',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Sjældent',
                    sublabel: '1-2 gange om måneden eller mindre',
                    value: 'low'
                },
                {
                    label: 'Ofte',
                    sublabel: '1-2 gange om ugen',
                    value: 'medium'
                },
                {
                    label: 'Meget ofte',
                    sublabel: 'Næsten hver dag',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Vælg land',
                    countries: [
                        { label: 'UK', value: 'en-GB' },
                        { label: 'US', value: 'en-US' },
                        { label: 'Canada', value: 'en-CA' },
                        { label: 'Danmark', value: 'da-DK' },
                        { label: 'Spanien', value: 'es-ES' },
                        { label: 'Finland', value: 'fi-FI' },
                        { label: 'Tyskland', value: 'de-DE' },
                        { label: 'Grækenland', value: 'el-GR' },
                        { label: 'Kroatien', value: 'hr-HR' },
                        { label: 'Norge', value: 'nb-NO' },
                        { label: 'Holland', value: 'nl-NL' },
                        { label: 'Sverige - østkyst', value: 'sv-SE_e' },
                        { label: 'Sverige - vestkyst', value: 'sv-SE_w' },
                        { label: 'Sverige - Søer', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Hav/Ocean', value: 'sea/ocean' },
                { label: 'Flod', value: 'rivers' },
                { label: 'Søer', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Vi Anbefaler',
            selection: {
                title: 'Dit valg',
                type: 'Bådtype',
                waterType: 'Type vand',
                material: 'Glass fiber',
                sailFrequency: 'Sailing',
                country: 'Land'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bedste køb',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bedste køb',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Find mere',
            whereToBuy: 'Hvor kan det købes',
            email: 'Email',
            send: 'Sende',
            feedback: {
                title: 'Var disse oplysninger nyttige?',
                yes: 'Ja',
                no: 'Nej',
                comment: 'Kommentar',
                placeholder: 'Kommenter her'
            },
            recommendation: {
                title: 'Send anbefaling via e-mail'
            },
            calculateVolume: 'Beregn produktmængde'
        }
    },
    calculate: {
        letsCalculate: 'Beregne',
        questions: {
            antifouling: 'Vælg Bundmailing',
            keelType: 'Bådtype?',
            dimensions: 'Indtast dimensionerne for din båds undervandsområde'
        },
        answers: {
            keelType: [
                {
                    label: 'Finnekøl',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Langkøl',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individuelle dimensioner'
                },
                {
                    title: 'ELLER undervandsareal i m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Enhed',
                    values: [{ label: 'Meters', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Længde af vandlinjen'
                },
                {
                    type: 'beam',
                    label: 'Dæksbredde'
                },
                {
                    type: 'draft',
                    label: 'Dybgang'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Nødvendig mængde',
            selection: {
                title: 'Dit valg',
                antifouling: 'Antifouling',
                type: 'Bådtype',
                material: 'Materialer',
                sailFrequency: 'Aktivitet',
                country: 'Land',
                keelType: 'Køl type',
                dimensions: 'Bådens mål'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Bedste køb',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Bedste køb',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Nødvendig mængde',
            suggestedAmountTwoCoats: 'Nødvendig mængde (2 lag)',
            oneCoat: '(1 lag)',
            fiveCoats: '(5 lag)',
            primerAltTiecoatSilic: 'Husk altid at anvende SilicOne Tiecoat!',
            primerAltSilicSealSilic:
                '<strong>CASE 2</strong><br/>Påføring oven på gammel bundmaling i god stand – nemt skift til Hempel’s Silic One-systemet',
            primerAlLightSilic:
                '<strong>CASE 1</strong><br/>Fjernelse af gammel bundmaling og påførelse af hele systemet & ny båd uden epoxy',
            primerAltTiecoat:
                '<strong>CASE 2: Trin 2</strong></br>... og derefter et lag Conversion Primer',
            primerAltSilicSeal:
                '<strong>CASE 2: Trin 1</strong><br/>Hvis båden ikke tidligere har fået antifouling, så start med at påføre et lag Light Primer (gå direkte til Trin 2)',
            primerAlLight:
                '<strong>CASE 1</strong><br/>Påføring ovenpå gammel antifouling maling i god stand',
            primer:
                '<strong>Bådens</strong> skrog er <strong>stærkt beskadiget</strong> eller <strong>maler du for første gang?</strong> Du skal bruge...',
            whereToBuy: 'Hvor kan det købes',
            email: 'Email',
            send: 'Send',
            or: 'ELLER',
            feedback: {
                title: 'Var disse oplysninger nyttige?',
                yes: 'Ja',
                no: 'Nej',
                comment: 'Kommentar',
                placeholder: 'Indtast din kommentar her'
            },
            recommendation: {
                title: 'Send anbefaling via e-mail'
            },
            calculateVolume: 'Beregn mængde'
        }
    },
    map: {
        country: 'Land',
        city: 'Stad',
        getDirections: 'Få anvisninger',
        placeholder: 'Alle byer...'
    },
    footer: 'Hempel Yacht - Alt, hvad du har brug for at vide om bådmaling.'
}
